<script>
import axios from "axios";
import LessonInstance from "@/components/ll/lesson-instance.vue";
import {toast} from "vue3-toastify";

export default {
  name: "my_lessons",
  components: {LessonInstance},
  props: ['admin'],
  data(){
    return {
      lessons:[],
      selectall: false,
      current_lesson:null,
      // Možnosti pro filtry
      companies: [],
      students: [],
      lectors: [],
      languages: [],
      lesson_instances:[],
      // Vybrané filtry
      selectedBType: '',
      selectedCompany: null,
      selectedStudent: null,
      selectedLector: null,
      selectedState: '',
      selectedLessonType: '',
      selectedLanguage: null,
      searchGroupName: '',
      dateFrom: '',
      dateTo: '',
      datePreset: '',
      searchDebounceTimer: null,
      hh:0
    }
  },
  mounted() {
    this.loadLessons()
  },
  watch:{
    selectall(){

      for(let i in this.lessons){
        this.lessons[i].selected = this.selectall
      }
      this.selected_ids()
    }

  },
  methods:{

    onSelectedCbChanged(){

      this.selected_ids()

    },
    selected_ids(){

      console.log('selected_ids volano')

      let arr = []
      for(let i in this.lessons){
        if (this.lessons[i].status=='denied') continue
        console.log('lesson ', this.lessons[i])
        if (this.lessons[i].selected){
          arr.push(this.lessons[i].id)
        }
      }
      this.hh = arr.length
      return arr
    },


    setStatus(l,value){

      axios.put(`/ll/lesson-instances/${l.id}/set-status.json`, {status: value}).then(re=>{
        if (re.status===200){
          this.loadLessons()
          toast.success("Status lekce změněn")
        }
      }).catch(e=>{
        toast.error("Chyba při změně statusu lekce: "+e.response.data.message)
      })


    },


    datetime_human(dateStr){
      const options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit' };
      return new Date(dateStr).toLocaleDateString(undefined, options);
    },
    loadLessons(){
      const url = `/ll/lesson_instances.json`
      axios.get(url, {
        params: this.get_lesson_params()
      }).then( response => {
        this.lessons = response.data.items
        this.companies = response.data.companies
        this.students = response.data.students
        this.lectors = response.data.lectors
        this.languages = response.data.languages
        this.sum_costs = response.data.sum_costs

        for(let i in this.lessons){
          this.lessons[i].selected = false
        }

      }).catch(error => {
        console.error('Došlo k chybě při načítání lekcí:', error);
      })
    },

    get_lesson_params(){
      const params = {
        b_type: this.selectedBType,
        company_id: this.selectedCompany,
        student_id: this.selectedStudent,
        lector_id: this.selectedLector,
        state: this.selectedState,
        lesson_type: this.selectedLessonType,
        language_id: this.selectedLanguage,
        group_name: this.searchGroupName,
        date_from: this.dateFrom,
        date_to: this.dateTo,
        date_preset: this.datePreset
      };

      // Odstranit null, undefined a prázdné řetězce
      return Object.fromEntries(
        Object.entries(params).filter(([_, value]) =>
          value !== null && value !== undefined && value !== ''
        )
      );
    },

    xlsxExport(){
      const params = this.get_lesson_params();
      const queryString = new URLSearchParams(params).toString();
      const url = `/ll/lesson_instances/export.xlsx${queryString ? '?' + queryString : ''}`;

      // Vytvoření dočasného odkazu pro stažení
      window.location.href = url;
    },

    handleGroupNameInput() {
      clearTimeout(this.searchDebounceTimer);
      this.searchDebounceTimer = setTimeout(() => {
        this.loadLessons();
      }, 500);
    },
    handleDatePresetChange() {
      if (this.datePreset === 'last_month') {
        const now = new Date();
        const firstDay = new Date(now.getFullYear(), now.getMonth() - 1, 1);
        const lastDay = new Date(now.getFullYear(), now.getMonth(), 0);
        this.dateFrom = firstDay.toISOString().split('T')[0];
        this.dateTo = lastDay.toISOString().split('T')[0];
      } else {
        this.dateFrom = '';
        this.dateTo = '';
      }
      this.loadLessons();
    },
    editLessonInstance(lesson){
      this.current_lesson = lesson
      this.$refs.lessonInstanceDialog.showModal()
    },
    deleteLessonInstance(lesson){
      if (confirm("Opravdu smazat tuto lekci?")){
        axios.delete(`/ll/lesson_instances/${lesson.id}.json`).then(re=>{
          if (re.status===200){
            this.loadLessons()
            toast.success("Lekce smazána")
          }
        }).catch(e=>{
          toast.error("Chyba při mazání lekce: "+e.response.data.message)
        })
      }
    },

    batchApprove(){
      const ids = this.selected_ids()
      if (ids.length==0){
        toast.error("Nevybrali jste žádné lekce")
        return
      }
      if (confirm(`Opravdu schválit ${ids.length} lekcí?`)){
        axios.put('/ll/lesson-instances/batch-approve.json', {ids: ids}).then(re=>{
          if (re.status===200){
            this.loadLessons()
            toast.success("Lekce schváleny")
          }
        }).catch(e=>{
          toast.error("Chyba při schvalování lekcí: "+e.response.data.message)
        })
      }

    },


  }
}/*
Filtr - od data do data (případně last calendar month),
podle Company,
podle Student/s,
podle stavu (inserted, approved, denied, all),
podle Types of lessons (on-to-one, 2 students (jen u B2B lekcí), group (jen u B2B lekcí), all)


vzor dat
   [
  {
    "id": 1,
    "when": "2026-01-02T21:56:00.000+01:00",
    "minutes": 45,
    "lecturer_id": 70,
    "lesson_topic": "dwedwed",
    "feedback": "wedwedwed",
    "lesson_state": "lesson_took_place",
    "additional_information": "wdwe",
    "next_lesson": null,
    "ll_lesson_id": 3,
    "students": [],
    "lecturer": {
      "id": 70,
      "email": "kate.duchackova@gmail.com",
      "first_name": "Katka",
      "last_name": "Ducháčková"
    },
    "lesson": {
      "id": 3,
      "lesson_type": "two_students",
      "language_level": null
    }
  },
*/

</script>

<template>
<div>
  <h3>Přehled odučených lekcí</h3>

  <div class="card mb-3">
    <div class="card-body">
      <h5>Filtry</h5>

      <div class="row">
        <!-- B2B/B2C -->
        <div class="col-md-3 mb-2">
          <label>Typ business</label>
          <select v-model="selectedBType" class="form-control" @change="loadLessons">
            <option value="">Všechny</option>
            <option value="b2b">B2B</option>
            <option value="b2c">B2C</option>
          </select>
        </div>

        <!-- Datum preset -->
        <div class="col-md-3 mb-2">
          <label>Časové období</label>
          <select v-model="datePreset" class="form-control" @change="handleDatePresetChange">
            <option value="">Vlastní rozsah</option>
            <option value="last_month">Minulý kalendářní měsíc</option>
          </select>
        </div>

        <!-- Od data -->
        <div class="col-md-3 mb-2">
          <label>Od data</label>
          <input type="date" v-model="dateFrom" class="form-control" @change="loadLessons">
        </div>

        <!-- Do data -->
        <div class="col-md-3 mb-2">
          <label>Do data</label>
          <input type="date" v-model="dateTo" class="form-control" @change="loadLessons">
        </div>
      </div>

      <div class="row">
        <!-- Společnost -->
        <div class="col-md-3 mb-2">
          <label>Společnost</label>
          <select v-model="selectedCompany" class="form-control" @change="loadLessons">
            <option :value="null">-- Všechny společnosti --</option>
            <option v-for="company in companies" :key="company.id" :value="company.id">
              {{ company.name }}
            </option>
          </select>
        </div>

        <!-- Student -->
        <div class="col-md-3 mb-2">
          <label>Student</label>
          <select v-model="selectedStudent" class="form-control" @change="loadLessons">
            <option :value="null">-- Všichni studenti --</option>
            <option v-for="student in students" :key="student.id" :value="student.id">
              {{ student.name }} {{ student.surname }} ({{ student.email }})
            </option>
          </select>
        </div>

        <!-- Lektor -->
        <div class="col-md-3 mb-2" v-if="admin">
          <label>Lektor</label>
          <select v-model="selectedLector" class="form-control" @change="loadLessons">
            <option :value="null">-- Všichni lektoři --</option>
            <option v-for="lector in lectors" :key="lector.id" :value="lector.id">
              {{ lector.first_name }} {{ lector.last_name }}
            </option>
          </select>
        </div>

        <!-- Stav -->
        <div class="col-md-3 mb-2">
          <label>Stav</label>
          <select v-model="selectedState" class="form-control" @change="loadLessons">
            <option value="">Všechny</option>
            <option value="inserted">Inserted</option>
            <option value="approved">Approved</option>
            <option value="denied">Denied</option>
          </select>
        </div>
      </div>

      <div class="row">
        <!-- Typ lekce -->
        <div class="col-md-3 mb-2">
          <label>Typ lekce</label>
          <select v-model="selectedLessonType" class="form-control" @change="loadLessons">
            <option value="">Všechny</option>
            <option value="one_to_one">One-to-one</option>
            <option value="two_students" v-if="selectedBType !== 'b2c'">2 students</option>
            <option value="group" v-if="selectedBType !== 'b2c'">Group</option>
          </select>
        </div>

        <!-- Jazyk -->
        <div class="col-md-3 mb-2">
          <label>Jazyk</label>
          <select v-model="selectedLanguage" class="form-control" @change="loadLessons">
            <option :value="null">-- Všechny jazyky --</option>
            <option v-for="language in languages" :key="language.id" :value="language.id">
              {{ language.name }}
            </option>
          </select>
        </div>

        <!-- Group name (pouze B2B) -->
        <div class="col-md-3 mb-2" v-if="selectedBType === 'b2b' || selectedBType === ''">
          <label>Název skupiny</label>
          <input
            type="text"
            v-model="searchGroupName"
            class="form-control"
            @input="handleGroupNameInput"
            placeholder="Hledat podle názvu skupiny"
          >
        </div>


        <div  class="col-md-1">
          <button @click="xlsxExport" class="btn btn-success">
            <span class="material-icons-outlined">download</span>
            Export XLSX
          </button>
        </div>

      </div>
    </div>
  </div>

  <div class="card">
    <div class="card-body">


      <div class="d-flex mb-2" v-if="hh>0">
    <div class="col" >
      HROMADNÉ AKCE (vybráno {{hh}}):  <button class=" btn  btn-success " @click.prevent="batchApprove">schválení</button>
     </div>
  </div>






      <table class="table table-striped">
        <thead>
          <tr>
            <th v-if="admin"><input type="checkbox" v-model="selectall"   /></th>
            <th>When</th>
            <th>Student/s</th>
            <th>How many minutes</th>
            <th>Lecturer</th>
            <th>Types of lessons</th>
            <th>Lesson topic</th>
            <th>Lesson state</th>
            <th>Status</th>
            <th>Costs</th>
            <th>Akce</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="lesson in lessons" :key="lesson.id">
            <td v-if="admin"><input type="checkbox" v-model="lesson.selected"  @change="onSelectedCbChanged" v-if="lesson.status!='denied'"/></td>


            <td>{{ datetime_human(lesson.when) }}</td>
            <td>
              <ul class="list-unstyled mb-0 small">
                <li v-for="student in lesson.students" :key="student.id">
                  <a :href="`/students/${student.id}`" target="_blank">{{ student.name }} {{ student.surname }} ({{ student.email }})</a>
                </li>
              </ul>
            </td>
            <td>{{ lesson.minutes }}</td>
            <td>{{ lesson.lecturer.first_name }} {{ lesson.lecturer.last_name }}</td>
            <td>{{ lesson.lesson.lesson_type }}</td>
            <td>{{lesson.lesson_topic }}</td>
            <td>{{lesson.lesson_state}}</td>
            <td>{{lesson.status}}</td>
            <td>{{lesson.computed_cost}}</td>

            <td>
              <div class="action-buttons-lessons">
                <a href="#" title="Approve" v-if="lesson.status=='inserted' && admin" @click.prevent="setStatus(lesson,'approved')" class="btn-icon btn-icon-approve">
                  <span class="material-icons-outlined">thumb_up</span>
                </a>
                <a href="#" title="Deny" v-if="lesson.status=='inserted' && admin" @click.prevent="setStatus(lesson,'denied')" class="btn-icon btn-icon-deny">
                  <span class="material-icons-outlined">thumb_down</span>
                </a>
                <a href="#" title="Edit" v-if="admin || lesson.status==='inserted'" @click.prevent="editLessonInstance(lesson)" class="btn-icon btn-icon-edit">
                  <span class="material-icons-outlined">mode_edit_outline</span>
                </a>
                <a href="#" title="Delete" v-if="admin || lesson.status==='inserted'" @click.prevent="deleteLessonInstance(lesson)" class="btn-icon btn-icon-delete">
                  <span class="material-icons-outlined">delete</span>
                </a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>


      <div class="row sumarow">
        <div class="col-md-10 sumarowcol">
          SUMA z vyfiltrovaných COSTS
        </div>
        <div class="col-md-2 sumarowcol ">
          {{sum_costs}}
        </div>
      </div>


    </div>
  </div>

  <lesson-instance :instance="current_lesson" ref="lessonInstanceDialog" @save-lesson-instance="loadLessons"></lesson-instance>
</div>
</template>

<style scoped>
.action-buttons-lessons {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  white-space: nowrap;
}

.btn-icon {
  cursor: pointer;
  text-decoration: none;
  transition: transform 0.2s ease, color 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.btn-icon:hover {
  transform: scale(1.15);
  text-decoration: none;
}

.btn-icon-approve {
  color: #28a745;
}

.btn-icon-approve:hover {
  color: #218838;
}

.btn-icon-deny {
  color: #fd7e14;
}

.btn-icon-deny:hover {
  color: #e66a00;
}

.btn-icon-edit {
  color: #007bff;
}

.btn-icon-edit:hover {
  color: #0056b3;
}

.btn-icon-delete {
  color: #dc3545;
}

.btn-icon-delete:hover {
  color: #a71d2a;
}

.btn-icon .material-icons-outlined {
  font-size: 20px;
}

.sumarow {
  border-top: 2px solid #333;
  margin-top: 10px;
  padding-top: 5px;
}

.sumarowcol {
  font-weight: bold;
}
</style>